
export default {
  name: 'BookBrochureware',

  props: {
    initialPaddockSlug: {
      type: String,
      default: null
    }
  },

  computed: {
    compSteps() {
      const steps = [
        {
          label: 'Book',
          status: 'current',
          to: '/book',
          isActive: true
        },
        {
          label: 'Register/Login',
          status: 'upcoming',
          to: '/book/checkout/register',
          isActive: !this.$app.isAuth
        },
        {
          label: 'Checkout',
          status: 'upcoming',
          to: '/book/checkout',
          isActive: true
        }
      ]

      return steps.filter(step => step.isActive)
    },

    compHero() {
      return {
        title: `Book Paw Paddock`,
        image: require('~/assets/images/backgrounds/booking-hero.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  }
}
